












































































































































































































































































































import _ from 'lodash';
import numeral from 'numeral';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { i18nMixin } from '../../mixins';

import KendoChart from '@/components/kendo-chart/kendo-chart.vue';
import { REPORT_GET_REPORTS } from '@/modules/neodash/store/modules/report/types';
import ReportLegend from '@/modules/neodash/components/report-legend/report-legend.vue';
import { PRINT_GET_PRINT_MODE, PRINT_GET_TABLE_MODE } from '@/store/modules/print/types';
import * as moment from 'moment';
import { NumberHelper } from '@/utils/number.helper';

@Component({
  components: {
    KendoChart,
    ReportLegend
  }
})
export default class MarketBreakDownSalesReport extends Vue {
  public translate = i18nMixin.methods.i18n;
  numeral = numeral;

  @Prop({ required: true })
  public state: any;

  @Getter(REPORT_GET_REPORTS)
  reports: any;

  @Getter(PRINT_GET_PRINT_MODE)
  printMode: any;

  @Getter(PRINT_GET_TABLE_MODE)
  tableMode: boolean;

  public clientName: string;
  public locality: string;
  public localityTitle: string;
  public typeSales: string;
  public salesReport = 2;
  public vocationReport = 3;

  public vocationAreaValues = {
    HigherPercentValue: 115.0,
    LowerPercentValue: 85.0
  };

  @Watch('state')
  public requestData() {
    this.localityTitle = this.state.requestData.TypeLocality.text;
    this.typeSales = this.getTypeSales(parseInt(this.state.requestData.SalesType.value));

    if (String(this.state.requestData.LevelLocality.value) !== '-1')
      this.state.requestData.GeoCodes = [this.state.requestData.ClientLocality.value];

    this.locality =
      String(this.state.requestData.LevelLocality.value) === '-1'
        ? this.state.requestData.TypeLocality.text
        : `${this.state.requestData.ClientLocality.text} ${this.state.requestData.TypeLocality.text}`;
  }

  public capitalize(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  public getPeriod() {
    const start = new Date(this.state.requestData.StartYear.value, this.state.requestData.StartMonth.value - 1, 1);
    const end = new Date(this.state.requestData.EndYear.value, this.state.requestData.EndMonth.value - 1, 1);

    return {
      start: this.capitalize(moment(start).format('MMM YYYY')),
      end: this.capitalize(moment(end).format('MMM YYYY'))
    };
  }

  public get models() {
    if (!_.size(this.state.dataSource)) {
      return [];
    }

    this.clientName = this.state.client;
    return this.state.dataSource;
  }

  public get industryRetailChart() {
    return _(this.models)
      .filter(f => f.desc_rel === 'Total Industria' && f.relatorio === this.salesReport)
      .map(f => {
        return {
          name: f.nm_pma,
          total: f.valor
        };
      })
      .orderBy(f => f.name)
      .map(f => f)
      .value();
  }

  public get clientRetailChart() {
    return _(this.models)
      .filter(f => f.desc_rel === 'Total Cliente' && f.relatorio === this.salesReport)
      .map(f => {
        return {
          name: f.nm_pma,
          total: f.valor
        };
      })
      .orderBy(f => f.name)
      .map(f => f)
      .value();
  }

  public get vocationChart() {
    return _(this.models)
      .filter(f => f.desc_rel === 'Vocação Venda' && f.relatorio === this.vocationReport)
      .map(f => {
        return {
          name: f.nm_pma,
          total: NumberHelper.percentNumber(f.valor),
          venda: NumberHelper.percentNumber(f.valor_venda)
        };
      })
      .orderBy(f => f.name)
      .map(f => f)
      .value();
  }

  public get outletsChart() {
    return _(this.models)
      .filter(f => (f.desc_rel === 'Outlets' || f.desc_rel === 'Outlets Industria') && f.relatorio === this.salesReport)
      .map(f => {
        return {
          name: f.nm_pma,
          total: f.desc_rel === 'Outlets' ? f.valor : 0,
          total_industria: f.desc_rel === 'Outlets Industria' ? f.valor : 0
        };
      })
      .flatten()
      .groupBy(f => f.name)
      .map((f, key) => {
        return {
          name: key,
          total: _.sumBy(f, 'total'),
          total_industria: _.sumBy(f, 'total_industria')
        };
      })
      .orderBy(f => f.name)
      .map(f => f)
      .value();
  }

  public getColor(val) {
    switch (true) {
      case val.value > this.vocationAreaValues.HigherPercentValue:
        return '#A9D08E';
      case val.value < this.vocationAreaValues.LowerPercentValue:
        return '#FF8B8B';
      default:
        return '#AEAAAA';
    }
  }

  public getColorIndustry(val) {
    switch (true) {
      case val.value > this.vocationAreaValues.HigherPercentValue:
        return '#61953D';
      case val.value < this.vocationAreaValues.LowerPercentValue:
        return '#FF3F3F';
      default:
        return '#717171';
    }
  }

  public getTypeSales(type) {
    switch (type) {
      case 1:
        return this.translate('Common.Retail');
      case 2:
        return this.translate('Common.DirectSales');
      case 3:
        return 'Total';
      default:
        return this.translate('Common.Retail');
    }
  }

  public created() {
    this.requestData();
  }
}
